module.exports = __webpack_public_path__ + "static/mr-concert-performance-08-c4c4235899f2be4b2d918ad5f8ecf3e6.jpg";